import React, { Fragment } from "react";
import { Card, CardImg, CardBody } from "reactstrap";
import styled from "styled-components";
import { data } from "./data/WorksData2";
import StrapModal from "./StrapModal";
import { Fade } from "react-reveal";

export default class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      activeCategory: "all",
      showModal: false,
      workTimes: [1]
    };
  }
  handleCategory = category => {
    this.setState({
      activeCategory: category
    });
  };
  handleCard = element => {
    this.setState({
      element: element,
      showModal: !this.state.showModal
    });
  };
  loadMore = () => {
    this.setState({
      workTimes: [...this.state.workTimes, 1]
    })
  };
  render() {
    return (
      <Fade right duration={1000} distance="20px">

      <div className="container work remove-padding">
        {this.state.showModal ? (
          <StrapModal
            handleCard={this.handleCard}
            modal={this.state.showModal}
            element={this.state.element}
          />
        ) : null}

       <span className="projects">  Personal projects </span>
        <div className="work-filter "> <p>
        NB ! The projects & achievements above are not the only one , there is other but are not shown here .</p>



          <span onClick={() => this.handleCategory("all")}>All - </span>
          <span onClick={() => this.handleCategory("proj")}>litle projects-</span>
          <span onClick={() => this.handleCategory("web")}>Website -</span>
          <span onClick={() => this.handleCategory("app")}>Mobile App -</span>
          <span onClick={() => this.handleCategory("SAP")}>SAP -</span>
          
            
        </div>
 
        <div className="cards-container">
          {this.state.workTimes.map((ele, key) => {
            return (
              <Cards

                key={key}
                handleCard={this.handleCard}
                activeCategory={this.state.activeCategory}
              />
            );
          })}
        </div>
      </div>
 
     </Fade> 
    );
  }
}


const Cards = props => {
  return (
    <Fragment>
      {data.map((ele, key) => {
        return (
          <CardSC key={key}
          category={ele.category}
          activecategory={props.activeCategory}>
           
            <CardBody className="body-card">
              <span className="card-category">  {ele.date} - {ele.category} </span>
              <span className="card-title"> {ele.title} </span>
              <span className="card-authority"> {ele.authority}  </span>
              <span className="card-tools"> {ele.tools}  </span>


            </CardBody>
          </CardSC>
        );
      })}
      
    </Fragment>
    
  );
};

const CardSC = styled(Card)`
  ${props =>
    props.activecategory === props.category || props.activecategory === "all"
      ? "opacity:1;visibility:visible"
      : "opacity:0;visibility:hidden;position:absolute"};
  transition: opacity 600ms, visibility 600ms;
`;



// WEBPACK FOOTER //
// ./src/components/Projects.js